export default class EmailCodeConfirmationInvalid extends Error {
  name = 'EmailCodeConfirmationInvalid';

  constructor(readonly message = 'Email CodeConfirmationInvalid') {
    super(message);
  }
}
